<template>
  <div v-if="show">
    <div class="modal olympic-modal letter fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="title-with-icon">
              <div class="title-with-icon__icon title-with-icon__icon_login"></div>
              <div class="title-with-icon__title">
                <span class="title-letter">Второй этап олимпиады</span>
              </div>
            </div>
            <button type="button" class="close modal-close" @click="$emit('close')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="olympics-step2-content">
              <div class="step2-image">
                <img src="/pic/owl.png" alt="Второй этап олимпиады" />
              </div>
              <div class="step2-text">
                <h3>Добро пожаловать на второй этап Олимпиады: Переговоры и заключение контракта</h3>
                <p class="step2-description">
                  Перед вами — ключевой момент: установление доверия с турецким партнёром, ведение переговоров, выбор условий оплаты и подготовка к таможенному оформлению.
                </p>
                <p class="step2-description">
                  Ваша задача — продемонстрировать мастерство ведения международных переговоров, понимание культурных нюансов, знание финансовых инструментов и регуляторных требований.
                </p>
                <p class="step2-description">
                  Удачи! От вас зависит, станет ли этот контакт долгосрочным партнёрством.
                </p>
                <div class="step2-button-container">
                  <button @click="handleBegin" class="btn btn-primary">
                    Начать второй этап
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>
</template>

<script>
export default {
  name: 'OlympicsStep2Modal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'begin'],
  methods: {
    handleBegin() {
      this.$emit('begin')
    }
  }
}
</script>

<style scoped>
.olympics-step2-content {
  text-align: center;
  padding: 2rem 0;
}

.step2-image {
  margin-bottom: 2rem;
}

.step2-image img {
  max-width: 200px;
  height: auto;
  border-radius: 8px;
}

.step2-text h3 {
  color: #002E5E;
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 2rem;
  line-height: 1.3;
}

.step2-description {
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: left;
}

.step2-button-container {
  margin-top: 3rem;
}

@media (max-width: 768px) {
  .step2-image img {
    max-width: 150px;
  }
  
  .step2-text h3 {
    font-size: 2rem;
  }
  
  .step2-description {
    font-size: 1.4rem;
    line-height: 2rem;
  }
}
</style>
